import CommonLocaleEN from '../domains/common/locales/en';

export default {
  restart: {
    sections: {
      submit: 'Create contest',
      contestDetails: 'Go to contest details',
    },
    title: {
      main: 'Restart your contest',
      review: 'Review contest settings',
      created: 'Invite your members and get ready to play!',
    },
    subTitle: 'Your existing settings from your last contest',
    introModal: {
      wrapperTitle: 'WELCOME TO',
      title: '{{templateName}} has been upgraded',
      text: "All {{templateName}} contests are now hosted on Splash Sports. Don't worry, your contest settings have been saved.",
      features: {
        entertainmentOnly: {
          _1: 'Free to play! No hosting fees for {{templateName}}',
          _2: 'Fast & automated live scoring',
          _3: 'Updated mobile app to follow your contests',
        },
        paid: {
          _1: 'Hassle-free entry fee collection',
          _2: 'Fast & automated live scoring',
          _3: 'Updated mobile app to follow your contests',
        },
      },
      cta: 'Continue',
    },
    pricingInfoModal: {
      title: 'Self-Managed Pricing',
      cta: 'Got it',
    },
  },
  create: {
    title: {
      main: 'Create contest',
      review: 'Contest setup',
    },
    sections: {
      submit: 'Continue',
    },
  },
  edit: {
    sections: {
      submit: 'Save changes',
    },
    title: {
      main: 'Edit contest',
      review: '',
    },
  },
  common: CommonLocaleEN,
};
